import { useEffect } from "react";
import { ActionButton, IconBrick } from "@hamlak/ui";
import type { ProfileCreateResponse } from "@/api/types";
import { t } from "@/i18n/ko";

type Props = { welcome: ProfileCreateResponse["welcome"]; onConfirm: () => void };

/**
 * F01-06 웰컴(시안 68:1468). 전용 다이얼로그: 브릭 원 + 제목 t9 + 본문 + brand "함락하러 가기". 금액·잔액은 서버 값만.
 * welcome === null이면 렌더하지 않는다. 오버레이 탭·Esc도 확인과 같다.
 */
export function WelcomeDialog({ welcome, onConfirm }: Props) {
  useEffect(() => {
    if (!welcome) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onConfirm();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [welcome, onConfirm]);
  if (!welcome) return null;
  return (
    <div className="welcome__overlay" onClick={onConfirm}>
      <div role="alertdialog" aria-modal="true" aria-labelledby="welcome-title" className="welcome" onClick={(e) => e.stopPropagation()}>
        <span className="welcome__icon" aria-hidden>
          <IconBrick size={56} />
        </span>
        <p id="welcome-title" className="welcome__title">
          {t("welcome.title", { amount: welcome.amount })}
        </p>
        <p className="welcome__body">{t("welcome.body")}</p>
        <ActionButton size="medium" block variant="brandSolid" onClick={onConfirm}>
          {t("welcome.cta")}
        </ActionButton>
      </div>
    </div>
  );
}
